import { useRef, useState } from "react";
import { FormInstance, Button, Form, Input, message } from "antd";
import { useNavigate } from "react-router-dom";

import classes from "./ForgetPassword.module.css";
import { resetPassword } from "api/consumerLogin";
import AuthScreenContainer from "containers/AuthScreenContainer";
import { VALIDATION } from "constants/strings";
import { STRONG_PASSWORD_PATTERN } from "utils/validation";

export const NewPassword = ({ email }: { email: string }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const formRef = useRef<FormInstance>(null);

  const handleSubmit = async () => {
    const { newPassword, confirmPassword } = formRef.current?.getFieldsValue();
    if (!newPassword || !confirmPassword) {
      message.error("Please enter your password");
      return;
    }
    if (newPassword !== confirmPassword) {
      message.error("Passwords do not match");
      return;
    }

    setLoading(true);
    const res = await resetPassword({ email, newPassword, confirmPassword });
    setLoading(false);
    if (res) {
      navigate("/login");
    }
  };

  return (
    <AuthScreenContainer
      heading="Set new password"
      subHeading="Enter a new password to reset your previous password"
      footerLinkText="Back to login"
      footerLink="/login">
      <div className={classes.ForgetPassword}>
        <Form
          className="Form"
          ref={formRef}
          style={{ width: "100%" }}
          onFinish={handleSubmit}
          layout="vertical"
          requiredMark={false}
        >
          <Form.Item 
            name="newPassword" 
            label={"Password"}
            normalize={value => value.trim()}
            rules={[
              {
                required: true,
                pattern: STRONG_PASSWORD_PATTERN,
                message: VALIDATION.passwordValidation
              }
            ]}
          >
            <Input.Password type="password" />
          </Form.Item>
          <Form.Item 
            name="confirmPassword" 
            label={"Repeat Password"}
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if(!value) {
                    return Promise.reject(VALIDATION.fieldIsRequired)
                  }

                  if (getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(VALIDATION.confirmPasswordValidation);
                },
              }),
            ]}
            dependencies={["newPassword"]}
          >
            <Input.Password type="password" />
          </Form.Item>
          <Button
            loading={loading}
            disabled={loading}
            style={{
              width: "100%",
              height: "56px",
              fontSize: "20px",
              fontWeight: 600,
              lineHeight: "29px",
              textAlign: "center",
              borderRadius: "8px",
            }}
            htmlType="submit">
            Confirm
          </Button>
        </Form>
      </div>
    </AuthScreenContainer>
  );
};
